var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 q-mt-md bg-white",
          attrs: { color: "white", "text-color": "primary", align: "justify" },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "user-info",
              icon: "fal fa-info",
              label: _vm.$q.platform.is.mobile ? "" : _vm.$t("user_info")
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "basic-data",
              icon: "fal fa-clipboard-list-check",
              label: _vm.$q.platform.is.mobile ? "" : _vm.$t("basic_data")
            },
            slot: "title"
          }),
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "certificates",
              icon: "fal fa-award",
              label: _vm.$q.platform.is.mobile ? "" : _vm.$t("certificates")
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { attrs: { name: "user-info", "keep-alive": "" } },
            [_c("user-info")],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "basic-data", "keep-alive": "" } },
            [_c("basic-data")],
            1
          ),
          _c(
            "q-tab-pane",
            { attrs: { name: "certificates", "keep-alive": "" } },
            [_c("certificates")],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }